import { Controller } from "@hotwired/stimulus"

// Rating widget controller — handles star hover preview
export default class extends Controller {
  // Minimal controller; form submission is handled natively.
  // Could add hover preview state in the future.
  connect() {}
}
